<template>
    <div>
        <sub-menu-faturamento ativo="creditos" v-if="!financeiro" />

        <config-main-title v-if="false">
            Créditos de Operadoras
        </config-main-title>

        <lancamento :block_redir="true" :view="true" :parms="{ natureza: 'O', filtros: { tipo_data: 'B', periodo: 'm' } }" :cred_oper="true" />
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import * as moment from 'moment';
import SubMenuFaturamento from './SubMenuFaturamento.vue';
import ConfigMainTitle from '../../cadastros/shared/ConfigMainTitle.vue';
import Lancamento from '../financeiro/Lancamento.vue';

export default {
    data() { 
        return { 
            dados: null, 
            inicio: "",
            fim: "", 
            id_operadora: "", 
            id_unidade_operacao: "", 
            id_recepcao: "", 
            tipo_data: "E", 
            firstLoad: false, 
            canceltoken: null, 
            periodo: "m",
            search: "", 
            filtros: { 
                periodo: "m",
                inicio: "",
                fim: "", 
                tipo_contrato: "", 
                tipo: "", 
                tipo_reembolso: "", 
                tipo_saldo: "", 
            },
            sintetico: true
        }
    },

    props: ['financeiro'],

    components: { 
        SubMenuFaturamento,
        ConfigMainTitle, 
        Lancamento,
    },

    computed: { 
        lista_recepcoes: function () { 
            if ( !this.id_unidade_operacao ) { 
                return [];
            }

            let unid = this.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == this.id_unidade_operacao);

            if ( unid ) { 
                return unid.recepcaos;
            } else { 
                return [];
            }
        },

        dadosFormatados: function () { 
            if ( this.sintetico ) { 
                return _.map(
                    this.tabela,
                    (items, operadora) => { 
                        return {
                            operadora: operadora, 
                            faturado: this.$util.formatMoeda(this.totalizar(items, 'valor')),
                            recebido: this.$util.formatMoeda(this.totalizar(items, 'recebido')),
                            glosado: this.$util.formatMoeda(this.totalizar(items, 'glosado')),
                            em_analise: this.$util.formatMoeda(this.totalizar(items, 'em_analise')),
                            acatado: this.$util.formatMoeda(this.totalizar(items, 'acatado')),
                            recursado: this.$util.formatMoeda(this.totalizar(items, 'reapresentado')),
                            recuperada: this.$util.formatMoeda(this.totalizar(items, 'recuperado')),
                            glosado_recurso: this.$util.formatMoeda(this.totalizar(items, 'glosado_nr')), 
                            definitiva: this.$util.formatMoeda(this.totalizar(items, 'definitiva')), 
                            saldo: this.$util.formatMoeda(this.totalizar(items, 'saldo')) 
                        }
                    }
                );
            } 

            if ( !this.dados || !this.dados.posicao )
                return [];

            return _.map(
                    this.dados.posicao,
                    item => { 
                        return {
                            operadora: item.st_operadora, 
                            tipo: this.dados.tipo == 'R' ? 'Recurso' : 'Fatura',
                            numero: item.id_fatura,
                            emissao: this.$util.getFormatDate(item.dt_emissao),
                            envio: this.$util.getFormatDate(item.dt_envio),
                            vencimento: this.$util.getFormatDate(item.dt_vencimento),
                            faturado: this.$util.formatMoeda(item.valor),
                            recebido: this.$util.formatMoeda(item.recebido),
                            glosado: this.$util.formatMoeda(item.glosado),
                            em_analise: this.$util.formatMoeda(item.em_analise),
                            acatado: this.$util.formatMoeda(item.acatado),
                            recursado: this.$util.formatMoeda(item.reapresentado),
                            recuperada: this.$util.formatMoeda(item.recuperado),
                            glosado_recurso: this.$util.formatMoeda(item.glosado_nr), 
                            definitiva: this.$util.formatMoeda(item.definitiva), 
                            saldo: this.$util.formatMoeda(Math.round(item.saldo * 100) / 100), 
                        }
                    }
                );
        },

        tabela: function () { 

            if ( !this.dados )
                return [];

            let lista;

            if ( this.search ) { 
                let reg = this.$util.getregex(this.search);
                lista = this.dados.posicao.filter(item => reg.test(JSON.stringify(item)));
            } else { 
                lista = this.dados.posicao;
            }

            return _.groupBy(lista, 'st_operadora');

        },

        graf_por_operadora: function () { 

            if ( !this.dados )
                return;

            
            
            let dados = _.map(this.tabela, (items, chave) => { 
                return { 
                    label: chave, 
                    valor: this.totalizar(items, 'glosado')
                };
            });

            dados = _.orderBy(dados, 'valor', 'desc');

            let data = _.slice(dados, 0, 4);
            let agrupados = _.slice(dados, 4, dados.length);

            if ( agrupados.length ) { 

                data.push({ 
                    label: 'Outros',
                    valor: agrupados.reduce((total, item) => { 
                        return total + item.valor;
                    }, 0)
                });

            }

            let labels = data.map(item => item.label);
            data = data.map(item => item.valor);

            return { 
                labels: labels,
                datasets: [
					{
						label: 'Glosa',
                        data: data,
                        backgroundColor: [
                            "#264643",
                            "#2A9D8F",
                            "#E9C46A",
                            "#F4A261",
                            "#E76F51",
                        ],
                    },
                ]
            };

        },

        graf_por_status: function () { 

            if ( !this.dados )
                return;

            let labels = ['Em Análise', 'Acatado', 'Recursado'];
            
            let dados = [
                this.totalizar(this.dados.posicao, 'em_analise'),
                this.totalizar(this.dados.posicao, 'acatado'),
                this.totalizar(this.dados.posicao, 'reapresentado'),
            ]
            
            return { 
                labels: labels,
                datasets: [
					{
						label: 'Glosa',
                        data: dados,
                        backgroundColor: [
                            "#264643",
                            "#2A9D8F",
                            "#E9C46A",
                            "#F4A261",
                            "#E76F51",
                        ],
                    },
                ]
            };

        },
    },

    methods: { 
        formatMoedaGrafico(value) { 
            let show = this.$util.formatMoeda(value);
            return show.substr(0,show.length - 3);
        },

        faturas (lista) { 
            return _.groupBy(lista, 'id_fatura');
        },

        percentual (total, parte) { 
            if ( total )
                return Math.round( ( parte / total ) * 100 ) + '%';
        },
        totalizar (items, campo) { 
            if ( !items )
                return 0;

            return items.filter(item => item[campo])
                .reduce((total, item) => total + parseFloat(item[campo]), 0);
        },

        load() { 

            if ( this.canceltoken ) {
                this.canceltoken.cancel('#BC#');
            }

            this.canceltoken = this.axios.CancelToken.source();

            $('.collapse').collapse('hide');

            /*
            inicio: this.inicio,
            fim: this.fim,
            periodo: this.periodo,
            */

            this.$util.load(this, { 
                service: 'faturas',
                func: 'glosas',
                redir_api: true, 
                parms: { 
                    tipo_data: this.tipo_data,
                    id_operadora: this.id_operadora,
                    id_unidade_operacao: this.id_unidade_operacao,
                    id_recepcao: this.id_recepcao, 
                    ...this.filtros,
                },
                canceltoken: this.canceltoken.token,
                callback: () => { 
                    this.firstLoad = true;
                }
            });
        },

        ajustar_fim() { 
            if ( !this.firstLoad )
                return;

            if ( this.inicio )
                this.fim = this.inicio;
        },
    },

    beforeMount () { 

        this.inicio = moment().subtract(30, "days").format('YYYY-MM-DD');
        this.fim = moment().format('YYYY-MM-DD');

    },

    mounted() { 
        this.$store.commit('setBreadcrumb', 
                [
                    { name: "Faturamento", path: "/faturamento/visao"},
                    { name: "Créditos de Operadoras", path: "/faturamento/creditos"},
                ]
            );
    }
}
</script>